import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a18c39c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "org-page" }
const _hoisted_2 = { class: "operation" }
const _hoisted_3 = { class: "bottom" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "custom-tree-node" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "del-icon" }, null, -1))
const _hoisted_8 = { class: "right ws_common_table" }

import { ref, onMounted, nextTick, computed } from 'vue'
import { queryOrgTreeList, orgInfoDelete, queryOrgTreeListDetail } from '@/api'
import { CODE_ENUM } from '@/common'
import OrgForm from './components/org-form.vue'
import { isEmpty } from 'lodash'
import { msgbox } from '@/utils'
import { ElMessage } from 'element-plus'
import Text from '@/components/text'
import i18n from '@/i18n'
import moment from 'moment'
import OperationButtonList from '@/components/operation-button-list'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authStore = useAuthStore()

const isSuperAdmin = computed(() => {
  return authStore.isSuperAdmin
})

const t = i18n.global.t

const treeRef = ref()

const getButtonList = () => {
  return [
    {
      text: '编辑',
      onClick: (row: any) => {
        toOrgForm(row)
      },
    },
    {
      text: '删除',
      onClick: (row: any) => {
        handleDelete(row)
      },
    },
  ]
}

const deepFormat = (
  list: any,
  level = 0,
  topOrgName = '-',
  parentOrgId?: any
) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, name, ...p } = item
    return {
      ...p,
      name,
      value: id,
      id,
      label: name,
      children: deepFormat(children, level + 1, name, id),
      level: level + 1,
      topOrgName,
      parentOrgId,
    }
  })
}

const dataMap = ref({})
const getDataMap = (list: any, mo = {}) => {
  if (isEmpty(list)) {
    return {}
  }
  const obj = list.reduce((m: any, el: any) => {
    m[el.id] = el.children || []
    if (!isEmpty(el.children)) {
      const mm = getDataMap(el.children, m)
      m = Object.assign(m, mm)
    }
    return m
  }, {})

  return Object.assign(obj, mo)
}

const col = [
  {
    label: '组织名称',
    prop: 'label',
  },
  {
    label: '上级组织',
    prop: 'topOrgName',
  },
  {
    label: '组织描述',
    prop: 'describe',
    formatter: ({ describe }: any) => {
      return describe || '-'
    },
  },
  {
    label: '创建时间',
    prop: 'createDate',
    formatter: ({ createDate }: any) => {
      return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
    },
  },
]

const handleNodeClick = ({ id }: any) => {
  tableData.value = dataMap.value[id]
  currentKey.value = id
}

const currentKey = ref()

const tableLoading = ref(false)
const dataSource: any = ref([])
const tableData: any = ref([])
const fetchList = async () => {
  const res: any = await queryOrgTreeListDetail()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const result = deepFormat([res.data])
    dataSource.value = result
    tableData.value = result
    dataMap.value = getDataMap(result)
    nextTick(() => {
      let id = res.data?.id
      if (!currentKey.value) {
        currentKey.value = id
        tableData.value = dataMap.value[id]
      } else {
        tableData.value = dataMap.value[currentKey.value]
        treeRef.value?.setCurrentKey(currentKey.value)
      }
    })
  }
}

onMounted(() => {
  fetchList()
})

const orgConf = ref({
  visible: false,
  data: {},
})

const toOrgForm = (data: any) => {
  orgConf.value = {
    visible: true,
    data,
  }
}

const handleDelete = (data: any) => {
  msgbox({
    tip: '删除组织将删除组织下的所有用户账号，请确认！',
    title: '是否确认删除',
    thenFn: () => toDelete(data),
  })
}

const toDelete = async ({ id }: any) => {
  const res: any = await orgInfoDelete({
    orgId: id,
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(isSuperAdmin))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: toOrgForm,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('ORG.btnAdd')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_tree, {
          class: "tree-list",
          data: dataSource.value,
          onNodeClick: handleNodeClick,
          "default-expand-all": "",
          "expand-on-click-node": false,
          "node-key": "id",
          ref_key: "treeRef",
          ref: treeRef,
          "highlight-current": true,
          "current-node-key": currentKey.value
        }, {
          default: _withCtx(({ node }) => [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(node.label), 1),
              _hoisted_7
            ])
          ]),
          _: 1
        }, 8, ["data", "current-node-key"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          stripe: ""
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, {
              description: _ctx.$t('CONFIG.noData')
            }, null, 8, ["description"])
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item) => {
              return _createVNode(_component_el_table_column, _mergeProps({
                key: item.prop
              }, { ...item }, { "show-overflow-tooltip": "" }), null, 16)
            }), 64)),
            (_unref(isSuperAdmin))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "operation",
                  label: _ctx.$t('CONFIG.roperation'),
                  width: "260"
                }, {
                  default: _withCtx((scoped) => [
                    _createVNode(_unref(OperationButtonList), {
                      buttonList: getButtonList(),
                      scope: scoped.row
                    }, null, 8, ["buttonList", "scope"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ])
      ])
    ]),
    _createVNode(OrgForm, {
      visible: orgConf.value.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((orgConf.value.visible) = $event)),
      data: orgConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ]))
}
}

})